import { useRef, useEffect } from 'react';
import IconButton from '@mui/material/IconButton';
import InputAdornment from '@mui/material/InputAdornment';

import classes from './classes.module.scss';

import {
  GREATER_THAN,
  GREATER_THAN_OR_EQUAL,
  LESS_THAN,
  LESS_THAN_OR_EQUAL,
  EQUALS,
  NOT_EQUAL,
  CONTAINS,
  NOT_CONTAINS
} from 'app/hooks/useFilter';

const FilterToggle = props => {
  const {
    filterType,
    filterTypes,
    setFilterType
  } = props;

  const filterTypeRef = useRef(filterType);
  useEffect(() => {
    filterTypeRef.current = filterType;
  }, [filterType]);

  const toggleFilterType = () => {
    let currentIndex = filterTypes.indexOf(filterTypeRef.current);

    let nextFilterType;
    if (currentIndex === filterTypes.length - 1) {
      nextFilterType = filterTypes[0];
    } else {
      nextFilterType = filterTypes[currentIndex + 1];
    }

    setFilterType(nextFilterType);
  }

  let inputSign, inputSignTooltip;
  switch (filterType) {
    case GREATER_THAN:
      inputSign = '>';
      inputSignTooltip = 'greater than';
      break;
    case GREATER_THAN_OR_EQUAL:
      inputSign = '>=';
      inputSignTooltip = 'greater than or equal';
      break;
    case LESS_THAN:
      inputSign = '<';
      inputSignTooltip = 'less than';
      break;
    case LESS_THAN_OR_EQUAL:
      inputSign = '<=';
      inputSignTooltip = 'less than or equal';
      break;
    case EQUALS:
      inputSign = '=';
      inputSignTooltip = 'equals';
      break;
    case NOT_EQUAL:
      inputSign = '!=';
      inputSignTooltip = 'not equal';
      break;
    case CONTAINS:
      inputSign = '~';
      inputSignTooltip = 'contains';
      break;
    case NOT_CONTAINS:
      inputSign = '!~';
      inputSignTooltip = "doesn't contain";
  }

  return (
    <InputAdornment position="start" sx={{marginTop: '0 !important'}}>
      <IconButton
        className={classes.filterIconButton}
        sx={{fontSize: '1rem !important'}}
        onClick={toggleFilterType}
        title={inputSignTooltip}
      >
        {inputSign}
      </IconButton>
    </InputAdornment>
  );
}

export default FilterToggle;
